import Flex from '@wiggui/ds/Flex'
import Button from '@wiggui/ds/Button'
import Modal from '@wiggui/ds/Modal'
import Text from '@wiggui/ds/Text'
import { useModalActiveAccount } from './hooks/useModalActiveAccount'
import { useModalActiveAccountStore } from '../../store'
import { PersonWithSvg } from '../../svg/PersonWithSvg'

export const ModalActiveAccount = () => {
  const { handleResendEmailVerification, onClose, isLoading } =
    useModalActiveAccount()
  const isOpen = useModalActiveAccountStore(
    (state) => state.modalActiveAccount.isOpen
  )

  return (
    <Modal
      enableBgBlur
      className="max-w-[600px]"
      isOpen={isOpen}
      onClose={onClose}
    >
      <Modal.Body>
        <Flex
          gap="gap-6"
          dir="row"
          className="flex-wrap md:flex-nowrap"
          items="center"
          justify="center"
          wFull
        >
          <PersonWithSvg />
          <Flex
            dir="col"
            items="start"
            justify="center"
            gap="gap-2"
            className="max-w-xs"
          >
            <Text className="text-headline-xs text-primary">
              Recuerda activar tu cuenta
            </Text>
            <Text className="text-body-m text-secondary">
              Para continuar es necesario que actives tu cuenta usando el correo
              que te enviamos. Puedes reenviarlo si lo necesitas.
            </Text>
          </Flex>
        </Flex>
      </Modal.Body>
      <Modal.Footer className="py-3 px-6 flex w-full flex-row items-center justify-center gap-3">
        <Button
          variant="terciary"
          isDisabled={isLoading}
          onClick={onClose}
          fullWidth
        >
          Cancelar
        </Button>
        <Button
          variant="secondary"
          isLoading={isLoading}
          onClick={handleResendEmailVerification}
          fullWidth
        >
          Reenviar correo de activación
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
